<template>
    <v-form @submit.prevent="save">
        <v-card class="mb-5 pa-2">
            <card-header :title="formTitle"></card-header>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="12">
                        <v-radio-group v-model="legal_person" row>
                            <v-card outlined class="mr-2">
                                <v-card-actions class="pa-5">
                                    <v-radio
                                        :label="
                                            $t(
                                                'resources.lead.labels.legal_person',
                                            )
                                        "
                                        :value="true"
                                    ></v-radio>
                                </v-card-actions>
                            </v-card>
                            <v-card outlined>
                                <v-card-actions class="pa-5">
                                    <v-radio
                                        :label="
                                            $t(
                                                'resources.lead.labels.normal_person',
                                            )
                                        "
                                        :value="false"
                                    ></v-radio>
                                </v-card-actions>
                            </v-card>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="4">
                        <v-text-field
                            flat
                            v-model="lead.trade_name"
                            :label="
                                legal_person
                                    ? $t('customer.form.labels.trade-name')
                                    : $t('customer.form.labels.name')
                            "
                            :counter="180"
                            :error-messages="tradeNameErrors"
                            @input="$v.lead.trade_name.$touch()"
                            @blur="$v.lead.trade_name.$touch()"
                            autofocus
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="4"
                        v-show="legal_person"
                    >
                        <v-text-field
                            flat
                            v-model="lead.legal_name"
                            :label="$t('customer.form.labels.legal_name')"
                            :counter="180"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="4"
                        v-show="!legal_person"
                    >
                        <v-text-field
                            flat
                            v-model="lead.cpf"
                            :label="$t('customer.form.labels.cpf')"
                            v-mask="'###.###.###-##'"
                            :counter="14"
                            :error-messages="cpfErrors"
                            @input="$v.lead.cpf.$touch()"
                            @blur="$v.lead.cpf.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="4"
                        v-show="!legal_person"
                    >
                        <v-text-field
                            flat
                            v-model="birthday"
                            :label="$t('prospects.form.labels.birthday')"
                            v-mask="'##/##/####'"
                            :counter="10"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        xs="12"
                        sm="12"
                        md="4"
                        v-show="legal_person"
                    >
                        <v-text-field
                            flat
                            v-model="lead.cnpj"
                            :label="$t('customer.form.labels.cnpj')"
                            v-mask="'XX.XXX.XXX/XXXX-##'"
                            :counter="18"
                            :error-messages="cnpjErrors"
                            @input="handleCnpjInput"
                            @blur="$v.lead.cnpj.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="4">
                        <v-text-field
                            flat
                            v-model="lead.email"
                            :label="$t('customer.form.labels.email')"
                            :error-messages="emailErrors"
                            @input="$v.lead.email.$touch()"
                            @blur="$v.lead.email.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="4">
                        <v-text-field
                            flat
                            v-model="lead.phone"
                            :label="$t('customer.form.labels.phone')"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            :error-messages="phoneErrors"
                            @input="$v.lead.phone.$touch()"
                            @blur="$v.lead.phone.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="4">
                        <v-select
                            v-model="lead.status"
                            :items="lead.statuses"
                            item-text="name"
                            item-value="value"
                            :label="$t('resources.lead.attributes.status')"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="lead.responsible_name"
                            :label="
                                $t('resources.lead.attributes.responsible_name')
                            "
                            :counter="180"
                            :error-messages="responsibleNameErrors"
                            @input="$v.lead.responsible_name.$touch()"
                            @blur="$v.lead.responsible_name.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="lead.activity_area"
                            :label="
                                $t('resources.lead.attributes.activity_area')
                            "
                            :counter="180"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="!lead.customer_id">
                    <v-col md="3">
                        <v-checkbox
                            v-model="lead.create_customer"
                            :label="$t('prospects.index.buttons.create-trial')"
                            :value="true"
                        >
                        </v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>
            <form-actions :loadingSave="loading"> </form-actions>
        </v-card>
    </v-form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mask } from 'vue-the-mask'
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import {
    required,
    minLength,
    maxLength,
    email,
    requiredIf,
} from 'vuelidate/lib/validators'

import BaseModel from '@/shared/orm/Model'

export default {
    props: {
        model: {
            type: Object,
            required: true,
            validator: model => {
                return model instanceof BaseModel
            },
        },
        isEdit: Boolean,
        titlePrefix: String,
    },

    data: () => {
        return {
            loading: false,
            legal_person: true,
            birthday: null,
            lead: this.model,
        }
    },

    components: {
        'card-header': CardHeader,
        'form-actions': FormActions,
    },

    directives: { mask },

    mixins: [validationMixin],

    validations: {
        lead: {
            trade_name: { required, maxLength: maxLength(180) },
            cpf: {
                required: requiredIf(customer => {
                    return !customer.cnpj
                }),
                minLength: minLength(14),
            },
            cnpj: {
                required: requiredIf(customer => {
                    return !customer.cpf
                }),
                minLength: minLength(18),
            },
            email: { required, email },
            phone: {
                required,
                minLength: minLength(14),
            },
            responsible_name: { required, maxLength: maxLength(180) },
        },
    },

    methods: {
        async save() {
            this.loading = true

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('form.messages.validation-error'),
                )

                this.loading = false
                return
            }

            let clone = this.lead.clone()
            clone.birthday = this.birthday
                ? this.$moment(this.birthday, 'DD/MM/YYYY')
                : null

            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('forms.messages.saved', {
                    resource: this.$tc('resources.lead.name', 1).toLowerCase(),
                    name: clone.trade_name,
                }),
            )

            this.$emit('saved')
        },

        handleCnpjInput(value) {
            this.lead.cnpj = value ? value.toUpperCase() : value
            this.$v.lead.cnpj.$touch()
        },
    },

    created() {
        if (this.isEdit && this.lead.cpf) {
            this.legal_person = false
        }

        if (this.isEdit) {
            this.birthday = this.lead.birthday
        }
    },

    computed: {
        formTitle() {
            return this.isEdit
                ? this.$t('prospects.form.title-edit')
                : this.$t('prospects.form.title-add')
        },

        tradeNameErrors() {
            const errors = []
            if (!this.$v.lead.trade_name.$dirty) return errors

            !this.$v.lead.trade_name.maxLength &&
                errors.push(
                    this.$t('customer.form.messages.name-error-max-length'),
                )

            !this.$v.lead.trade_name.required &&
                errors.push(
                    this.$t('customer.form.messages.name-error-required'),
                )
            return errors
        },

        cpfErrors() {
            const errors = []
            if (!this.$v.lead.cpf.$dirty) return errors

            !this.$v.lead.cpf.required &&
                errors.push(
                    this.$t('customer.form.messages.cpf-error-required'),
                )

            !this.$v.lead.cpf.minLength &&
                errors.push(
                    this.$t('customer.form.messages.cpf-error-min-length'),
                )

            return errors
        },

        cnpjErrors() {
            const errors = []
            if (!this.$v.lead.cnpj.$dirty) return errors

            !this.$v.lead.cnpj.required &&
                errors.push(
                    this.$t('customer.form.messages.cnpj-error-required'),
                )

            !this.$v.lead.cnpj.minLength &&
                errors.push(
                    this.$t('customer.form.messages.cnpj-error-min-length'),
                )

            return errors
        },

        emailErrors() {
            const errors = []
            if (!this.$v.lead.email.$dirty) return errors

            !this.$v.lead.email.required &&
                errors.push(
                    this.$t('customer.form.messages.email-error-required'),
                )

            !this.$v.lead.email.email &&
                errors.push(this.$t('customer.form.messages.email-error-email'))

            return errors
        },

        phoneErrors() {
            const errors = []
            if (!this.$v.lead.phone.$dirty) return errors

            !this.$v.lead.phone.required &&
                errors.push(
                    this.$t('customer.form.messages.phone-error-required'),
                )

            !this.$v.lead.phone.minLength &&
                errors.push(
                    this.$t('customer.form.messages.phone-error-min-length'),
                )

            return errors
        },
        responsibleNameErrors() {
            const errors = []
            if (!this.$v.lead.responsible_name.$dirty) return errors

            !this.$v.lead.responsible_name.required &&
                errors.push(
                    this.$t(
                        'customer.form.messages.responsible-name-error-required',
                    ),
                )

            return errors
        },
    },
}
</script>
